import { SET_PLANS } from "./types";
import { apiCallV2 } from "../../../utils/api";
import { CallPlanStart } from "../impact/actions";

export const LoadPlans = () => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "get-subscription-plans");

    if (res.status === 200) {
        dispatch({
            type: SET_PLANS,
            details: res.data.data,
        });
    }
};

export const CreatePurchase = (createPurchaseObj, plan) => async (dispatch, getState) => {
    const { account } = getState().User;

    const orderDetails = {
        customerStatus: "New",
        currencyCode: "USD",
        orderPromoCode: "",
        orderDiscount: 0,
        items: [
            {
                subTotal: 0,
                category: plan.code,
                sku: plan.id,
                quantity: 1,
                name: plan.name,
            },
        ],
    };

    const res = await apiCallV2("POST", "create-purchase", createPurchaseObj, localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"));

    if (res.data.status == 200) {

        CallPlanStart(orderDetails, account?.user)();

        localStorage.setItem("requirement_status", createPurchaseObj?.renewal ? 3 : 1);
        localStorage.removeItem("expired");

        return {
            status: res.data.status,
        };
    } else {
        return {
            status: res.data.status,
            message: res.data?.message,
        };
    }
};

export const CreatePurchaseDirect = (createPurchaseObj, plan) => async (dispatch, getState) => {
    const { account } = getState().User;

    const orderDetails = {
        currencyCode: "USD",
        orderPromoCode: "",
        orderDiscount: 0,
        items: [
            {
                subTotal: 0,
                category: plan.code,
                sku: plan.id,
                quantity: 1,
                name: plan.name,
            },
        ],
    };

    const res = await apiCallV2("POST", "create-purchase-direct", createPurchaseObj, localStorage.getItem("access-token") || localStorage.getItem("temp-access-token"));

    if (res.data.status == 200) {

        CallPlanStart(orderDetails, account?.user)();

        localStorage.setItem("requirement_status", createPurchaseObj?.renewal ? 3 : 1);
        localStorage.removeItem("expired");

        return {
            status: res.data.status,
        };
    } else {
        return {
            status: res.data.status,
            message: res.data?.message,
        };
    }
};

export const CreatePurchaseUsingCoupon = (code) => async (dispatch, getState) => {
    const { user } = getState().User;

    const res = await apiCallV2(
        "POST",
        "create-purchase-using-coupon",
        {
            code: code,
        },
        localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
    );

    if (res.data.status == 200) {
        return {
            status: res.data.status,
            date: res.data.data.currentPeriodEndsAt,
        };
    } else {
        return {
            status: res.data.status,
            message: res.data?.message,
        };
    }
};

export const CreatePurchaseWhilePromo =
    (createPurchaseObj, plan, term = "term_end") =>
        async (dispatch, getState) => {
            const { account } = getState().User;

            const orderDetails = {
                currencyCode: "USD",
                orderPromoCode: "",
                orderDiscount: 0,
                items: [
                    {
                        subTotal: 0,
                        category: plan.code,
                        sku: plan.id,
                        quantity: 1,
                        name: plan.name,
                    },
                ],
            };

            const { billing } = getState().User;

            const resBilling = await apiCallV2(
                "POST",
                "/update-billing-details",
                {
                    token: {
                        id: createPurchaseObj.rjs_token,
                    },
                },
                localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
            );

            if (resBilling.status == 200 && resBilling.data.status == 200) {
                const res = await apiCallV2(
                    "POST",
                    "create-purchase-while-in-promo",
                    {
                        ...createPurchaseObj,
                        term: term,
                    },
                    localStorage.getItem("access-token") || localStorage.getItem("temp-access-token")
                );

                if (res.data.status == 200) {

                    CallPlanStart(orderDetails, account?.user)();

                    localStorage.setItem("requirement_status", createPurchaseObj?.renewal ? 3 : 1);
                    localStorage.removeItem("expired");

                    return {
                        status: res.data.status,
                    };
                } else {
                    return {
                        status: res.data.status,
                        message: res.data?.message,
                    };
                }
            } else {
                return {
                    status: 406,
                    message: "Purchase Failed: Please review card details.",
                };
            }
        };

export const GetPlanSaleInfo = (id) => async (dispatch, getState) => {
    const res = await apiCallV2("GET", "get-plan-sale-info", "", localStorage.getItem("access-token"), {
        saleID: id,
    });

    if (res?.data?.status == 200 && res?.data?.data?.sale?.id) {
        return {
            success: res?.data?.data?.sale?.id ? true : false,
            data: {
                ...res?.data?.data,
            },
        };
    } else {
        return {
            success: false,
        };
    }
};
